import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { AppMisc } from "../../../../misc/appMisc"
import { AppUtils } from "../../../../utils/appUtils"
import { useEffect, useRef, useState } from "react"
import AHMIS, { API_URL } from "../../../../api/api"
import AddAlertMessage from "../../../../components/alert/Alert"
import { AYURVEDIC_THERAPY, ERROR, SOMETHING_WENT_WRONG } from "../../../../utils/constants"
import { DateUtils } from "../../../../utils/dateUtils"
import styles from "./styles"
import ReactToPrint from "react-to-print"
import { Print } from "@mui/icons-material"
import HealthServiceCardHeader from "../health-service-card-header/HealthServiceCardHeader"
import { NEW_PATIENT, PREVIOUS_PATIENT } from "../../../../utils/constants/forms"

const HealthServiceCard = () => {
  const [healthServiceCardTableData, setHealthServiceCardTableData] = useState();
  const id = AppUtils.getUrlParam("id");
  const fromMulDartaaRegister = AppUtils.getUrlParam("fromMulDartaaRegister");
  const printComponentRef = useRef();
  const classes = styles();

  useEffect(() => {
    getTableData();
  }, []);

  const getTableData = async () => {
    const url = fromMulDartaaRegister ? API_URL.mulDartaaRegister + "/" + id : API_URL.outPatient + "/" + id;
    try {
      const response = await AHMIS.get(url);
      setHealthServiceCardTableData(response?.data.data);
    } catch (error) {
      AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
    }
  };

  const getVitalsFormat = (height, weight, temperature, bloodPressure, pulseRate, respRate, spO2) => {
    return (
      <Box display="flex" alignItems="center" flexWrap="wrap" gap={2}>
        <Typography variant="subtitle2">
          Vitals:
        </Typography>
        {height && <Typography variant="subtitle2">Height. {height}</Typography>}
        {weight && <Typography variant="subtitle2">Weight. {weight}</Typography>}
        {temperature && <Typography variant="subtitle2">Temperature {temperature}°C</Typography>}
        {bloodPressure && <Typography variant="subtitle2">B.P {bloodPressure}</Typography>}
        {pulseRate && <Typography variant="subtitle2">Pulse {pulseRate}</Typography>}
        {respRate && <Typography variant="subtitle2">Respiratory Rate {respRate}</Typography>}
        {spO2 && <Typography variant="subtitle2">SpO2 {spO2}%</Typography>}
      </Box>
    );
  }

  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Box display={"flex"} justifyContent={"flex-end"} margin={3}>
            <IconButton>
              <Print />
            </IconButton>
          </Box>
        )}
        content={() => printComponentRef.current}
      />
      {healthServiceCardTableData &&
        <Box ref={printComponentRef}>
          <HealthServiceCardHeader />
          <Typography align="end" my={1}>{`मिति : ${AppUtils.replaceWithNepaliDigit(DateUtils.getDateFromMilliseconds(healthServiceCardTableData?.dartaaMiti))}`}</Typography>
          <TableContainer>
            <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Health Service Card">
              <TableHead classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell>मूल दर्ता नं</TableCell>
                  <TableCell>{healthServiceCardTableData?.mulDartaaNumber}</TableCell>
                  <TableCell>नाम, थर</TableCell>
                  <TableCell>जाति कोड</TableCell>
                  <TableCell>लिङ्ग</TableCell>
                  <TableCell>उमेर</TableCell>
                  <TableCell>शुल्क</TableCell>
                </TableRow>
              </TableHead>
              <TableBody classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell>ORC दर्ता नं.</TableCell>
                  <TableCell>-</TableCell>
                  <TableCell>{healthServiceCardTableData.patientFirstName} {healthServiceCardTableData.patientLastName}</TableCell>
                  <TableCell>{healthServiceCardTableData?.casteCode && AppMisc.getCasteCodeLabelWithTooltip(healthServiceCardTableData.casteCode)}</TableCell>
                  <TableCell>{AppMisc.getGenderLabel(healthServiceCardTableData.gender)}</TableCell>
                  <TableCell>{healthServiceCardTableData?.age && AppUtils.replaceWithNepaliDigit(healthServiceCardTableData.age) + " "} {healthServiceCardTableData?.ageUnit && AppMisc.getAgeUnitLabel(healthServiceCardTableData.ageUnit)}</TableCell>
                  <TableCell>{healthServiceCardTableData?.cost && healthServiceCardTableData?.cost === "नि:शुल्क" ? healthServiceCardTableData?.cost : AppUtils.replaceWithNepaliDigit(healthServiceCardTableData?.cost)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Box mt={1.5} />
            <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Health Service Card">
              <TableHead classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell rowTypography={2}>ठेगाना</TableCell>
                  <TableCell>जिल्ला</TableCell>
                  <TableCell>नगर/गाउँपालिका</TableCell>
                  <TableCell>वडा नं.</TableCell>
                  <TableCell>सम्पर्क नम्बर</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{AppMisc.getDistrictName(healthServiceCardTableData.district)}</TableCell>
                  <TableCell>{AppMisc.getMunicipalityName(healthServiceCardTableData?.palikaName)}</TableCell>
                  <TableCell>{AppUtils.replaceWithNepaliDigit(healthServiceCardTableData?.wardNumber)}</TableCell>
                  <TableCell>{AppUtils.replaceWithNepaliDigit(healthServiceCardTableData?.phoneNumber)}</TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
          {!fromMulDartaaRegister &&
            <Box mt={2}>
              {getVitalsFormat(healthServiceCardTableData?.temperature || healthServiceCardTableData?.temperatureInCelsius, healthServiceCardTableData?.pulseRate, healthServiceCardTableData?.respPerMin, healthServiceCardTableData?.bloodPressure, healthServiceCardTableData?.spO2)}
              <Typography mt={2}>प्रयोगशाला/निदानात्मक परीक्षण : {healthServiceCardTableData?.labTests ? healthServiceCardTableData.labTests : "..........................................."}</Typography>
            </Box>
          }
          <TableContainer className={classes.marginTop}>
            <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Health Service Card">
              <TableHead classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell colSpan={2}>मिति</TableCell>
                  <TableCell rowSpan={2}>सेवा विवरण</TableCell>
                  <TableCell rowSpan={2}>सल्लाह</TableCell>
                  <TableCell rowSpan={2}>फर्केर आउने मिति</TableCell>
                  <TableCell rowSpan={2}>सेवा प्रदायकको सही</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>नयाँ</TableCell>
                  <TableCell>पुरानो</TableCell>
                </TableRow>
              </TableHead>
              <TableBody classes={{ root: "align-center" }}>
                {!fromMulDartaaRegister ? (
                  <TableRow>
                    <TableCell>{healthServiceCardTableData?.patientType === NEW_PATIENT ? AppUtils.replaceWithNepaliDigit(DateUtils.getDateFromMilliseconds(healthServiceCardTableData?.dartaaMiti)) : ''}</TableCell>
                    <TableCell>{healthServiceCardTableData?.patientType === PREVIOUS_PATIENT ? AppUtils.replaceWithNepaliDigit(DateUtils.getDateFromMilliseconds(healthServiceCardTableData?.dartaaMiti)) : ''}</TableCell>
                    <TableCell>{healthServiceCardTableData?.ayurvedicTherapy ? AppMisc.getLabelsFromArrayValue(healthServiceCardTableData.ayurvedicTherapy, AYURVEDIC_THERAPY) : "-"}</TableCell>
                    <TableCell>{healthServiceCardTableData?.tratementAndSuggestion}</TableCell>
                    <TableCell>{healthServiceCardTableData?.follwUpDate ? AppUtils.replaceWithNepaliDigit(DateUtils.getDateFromMilliseconds(healthServiceCardTableData?.follwUpDate)) : '-'}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                ) : (
                  <TableRow className={classes.emptyHealthServiceCardHeight}>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </TableContainer>
          <Typography align="center" mt={2}>अर्को पटक आउँदा यो पुर्जा अनिवार्य लिएर आउनु होला।</Typography>
        </Box>
      }
    </>
  )
}

export default HealthServiceCard
